import React from "react"

interface RocketLaunchIconProps {
	className: string
}

export function RocketLaunchIcon({className}: RocketLaunchIconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" className={className}>
			<path
				fill="#fff"
				d="M21.05 4.429A1.312 1.312 0 0 0 19.82 3.2c-1.154-.069-4.103.036-6.551 2.484l-.502.502H7.22a1.303 1.303 0 0 0-.927.385l-3.22 3.22a1.313 1.313 0 0 0 .744 2.227l3.669.512 4.233 4.233.512 3.673a1.312 1.312 0 0 0 2.228.743l3.22-3.22a1.305 1.305 0 0 0 .384-.928v-5.55l.502-.501c2.447-2.45 2.553-5.397 2.484-6.552ZM3.822 10.78a.188.188 0 0 1 .046-.187l3.22-3.227a.188.188 0 0 1 .131-.055h4.422L7.55 11.404l-3.575-.5a.18.18 0 0 1-.152-.123Zm13.114 6.249c0 .05-.02.097-.055.132l-3.218 3.22a.188.188 0 0 1-.32-.105l-.498-3.577 4.091-4.093v4.423Zm.832-6.844-5.52 5.518L8.547 12l5.519-5.52a7.357 7.357 0 0 1 5.69-2.156.188.188 0 0 1 .171.176 7.357 7.357 0 0 1-2.156 5.685h-.001ZM9.625 17.84c-.405.894-1.77 2.971-5.625 2.971a.562.562 0 0 1-.563-.562c0-3.856 2.078-5.22 2.971-5.625a.564.564 0 0 1 .47 1.024c-.657.297-2.113 1.267-2.295 4.023 2.755-.182 3.726-1.643 4.023-2.295a.563.563 0 1 1 1.024.47l-.005-.006Z"
			/>
		</svg>
	)
}
